module.exports = __webpack_public_path__ + "static/img/icon-training3.0009767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-training3.png
// module id = O739
// module chunks = 21